import React from 'react'
import ReactDOM from 'react-dom/client'
// Side-effect: registers apiClient with @procoach/shared before any API calls
import './api/client'
import '@shared/index.css'
import App from './App'
import { initMockTelegram } from './utils/mockTelegram'
import { loadMiniAppBridge } from '@shared/utils/miniAppBridge'

// Инициализируем мок Telegram в dev режиме
initMockTelegram()

// Загружаем SDK только текущего мессенджера до первого рендера.
// Недоступный telegram.org не должен блокировать запуск приложения в MAX.
void loadMiniAppBridge().then(() => {
  ReactDOM.createRoot(document.getElementById('root')!).render(
    <React.StrictMode>
      <App />
    </React.StrictMode>,
  )
}).catch(() => {
  const root = document.getElementById('root')!
  const message = document.createElement('p')
  message.textContent = 'Не удалось загрузить приложение. Проверьте соединение и попробуйте ещё раз.'
  const retry = document.createElement('button')
  retry.textContent = 'Повторить'
  retry.onclick = () => window.location.reload()
  root.replaceChildren(message, retry)
})
